// Copyright © 2023 CATTLEytics Inc.
export const defaultColor = '#666666';
export const defaultDateFormat = 'yyyy-MM-dd';
export const defaultNodeDiameter = 25;
